<template>
  <div id="app">
    <section id="calculadoraCltPj">
      <header>
        <h1 class="title">Calculadora PJ x CLT x Autônomo</h1>
        <h2 class="subtitle">Cálculo de salário e contratação {{ currentYear }}. Compare os custos de contratação e descubra qual a melhor modalidade de contratação para você CLT ou PJ.</h2>
      </header>

      <div v-if="!isCalculoDone && !loading">
        <botao-switch :on-click="switchFunc"/>

        <form
          id="form-group"
          @submit.prevent="onClickContinue()">
          <label>
            <strong>Eu sou:</strong>
          </label>
          <dropdown
            :items="filteredContratacaoList"
            :external-select="selectTipoContratacao"
            :selected-item="tipoContratacao"
            placeholder="Selecione o tipo de contratação"
          />

          <label for="valor">
            <strong>Eu recebo mensalmente (bruto):</strong>
          </label>
          <div :class="['input-group',{ 'icon-valid': (validacoes.salario) }, { 'icon-error': (salario > 0) }]" >
          <input
            v-money="money"
            id="valor"
            v-model.lazy="salario"
            v-bind="money"
            name="valor"
            @input="validacoes.salario = validators.recebeMensalmente.valid(salario, 500)"
            
            class="base-input money form-control"
          />
          </div>

          <label>
            <strong>Penso em mudar a forma de contratação em:</strong>
          </label>
          <dropdown
            :items="tempoParaMudarList"
            :external-select="selectTempoParaMudar"
            :selected-item="tempoParaMudar"
            placeholder="Selecione o prazo"
          />

          <label>
            <strong>Qual atividade eu exerço?</strong>
          </label>
          <dropdown
            :items="atividades"
            :external-select="selectAtividade"
            :selected-item="atividade"
            placeholder="Selecione sua atividade"
          />

          <label
            v-if="typeof fields.nome === 'string'"
            for="nome">
            <strong>Nome Completo:</strong>
          </label>
          <div
            v-if="typeof fields.nome === 'string'"
            :class="['input-group',{ 'icon-valid': (validacoes.nome && fields.nome.length > 0) }, { 'icon-error': (!validacoes.nome && fields.nome.length > 0) }]" >
            <input
              id="nome"
              name="nome"
              v-model="fields.nome"
              class="base-input"
              type="text"
              placeholder="Insira seu nome"
              @input="isNomeValid()"
            >
          </div>

          <label
            v-if="typeof fields.email === 'string'"
            for="email">
            <strong>E-mail:</strong>
          </label>
          <div
            v-if="typeof fields.email === 'string'"
            :class="['input-group',{ 'icon-valid': (validacoes.email && fields.email.length > 0) }, { 'icon-error': (!validacoes.email && fields.email.length > 0) }]" >
            <input
              id="email"
              name="email"
              v-model="fields.email"
              class="base-input"
              type="mail"
              placeholder="Insira seu e-mail aqui"
              @input="isEmailValid()"
            >
          </div>

          <label
            v-if="typeof fields.celular === 'string'"
            for="celular">
            <strong>Whatsapp:</strong>
          </label>
            <div
              v-if="typeof fields.celular === 'string'"
              :class="['input-group',{ 'icon-valid': (validacoes.celular) }, { 'icon-error': fields.celular.length > 0 &&!validacoes.celular }]" >
              <input
                id="celular"
                name="celular"
                v-model="fields.celular"
                v-mask="'(##)#####-####'"
                class="base-input"
                type="text"
                placeholder="(DD) 0000-0000"
                @input="isCelularValid()"
              >
          </div>

          <label
            :class="{active: subscribe}"
            class="subscribeLabel"
            for="subscribe">
            <div class="icon-check" />
            <span>Aceito receber dicas de como abrir empresa, conteúdos promocionais e contato da Contabilizei.</span>
          </label>
          <input
            id="subscribe"
            v-model="subscribe"
            hidden
            type="checkbox"
            name="subscribe">

          <button
            :style="customButtonStyle"
            class="light-blue-filled-theme big">
              CALCULAR SALÁRIO
          </button>
        </form>
      </div>

      <div
        v-if="loading"
        id="loading"
        class="loading">
        <span class="spinner" />
        <h3>Aguarde</h3>
        <p>Calculando...</p>
      </div>

      <div
        v-if="isCalculoDone && !loading"
        id="resultsFull"
        class="resultsFull">

        <div class="resultsResume">
          <div class="item">
            <span
              v-if="tipoContratacaoFormatted === 'CLT'"
              class="label">Seu salário líquido atual + benefícios como <strong>CLT</strong>:</span>
            <span
              v-else
              class="label">Seu salário líquido atual como <strong>{{ tipoContratacaoFormatted }}</strong>:</span>
            <span class="value">
              R$
              <strong>{{ valueLeft | currency }}</strong>
            </span>
          </div>

          <div class="item">
            <span class="label">Para receber o mesmo como <strong>{{ tipoOpostoFormatted }}</strong>, seu salário bruto precisa ser:</span>
            <span class="value highlight">
              R$
              <strong>{{ valueRight | currency }}</strong>
            </span>
          </div>
        </div>

        <div class="refazerCalculo">
          <span @click="resetCalculo">Refazer o cálculo</span>
        </div>

        <span class="linha-divisoria" />

        <div id="conhecaCtbz">
          <div v-if="!feedbackContato">
            <h3>Vai trabalhar como PJ e precisa abrir empresa? Abra Seu CNPJ de forma gratuita!</h3>

            <form
              id="form-group"
              @submit.prevent="falarEspecialista()">
              <button
                :style="customButtonStyleEspecialista"
                class="light-blue-filled-theme big">
                  FALE COM UM ESPECIALISTA
              </button>
            </form>
          </div>

          <div v-else id="feedbackContato">
            <h3 class="titulo">TUDO CERTO!</h3>
            <p class="descricao">Recebemos suas informações, logo nossos especialistas entrarão em contato.</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import BotaoSwitch from './components/BotaoSwitch.vue'
import listaCidadesAtendidas from '@/assets/json/ListaCompletaCidadesAtendidas.json';
import ValidatorSalary from '@/assets/js/util/validationRules/Salary';

import Dropdown from './components/Dropdown.vue'
import calculadoraCltPjV2 from '@/assets/js/calcularSalariosV2'
import calcularSalarios from '@/assets/js/calcularSalarios'
import atividadesJson from '@/assets/json/atividades.json'
import ListTlds from '@/assets/json/lista-tlds-validos.json';

import { activeFields, activeValidations } from './fields';

import { VMoney } from 'v-money';
import axios from 'axios';

export default {
  name: 'App',
  components: {
    BotaoSwitch,
    Dropdown,
  },
  directives: {
    money: VMoney
  },
  data() {
    return {
      fields: {
        ...activeFields,
      },
      VUE_APP_API_HUBSPOT: '',
      calculadoraTipo: 'id1',
      salario: '',
      beneficios: '',
      tipoContratacao: '',
      tempoParaMudar: '',
      atividade: '',
      cidadeAtendida: false,
      tipoOposto: '',
      subscribe: false,
      feedbackContato: false,
      activityList: atividadesJson,
      atividades: atividadesJson,
      isCalculoDone: false,
      loading: false,
      ddd: [ "11", "12", "13", "14", "15", "16", "17", "18", "19", "21", "22", "24", "27", "28", "31", "32", 
      "33", "34", "35", "37", "38", "41", "42", "43", "44", "45", "46", "47", "48", "49", "51", 
      "53", "54", "55", "61", "62", "63", "64", "65", "66", "67", "68", "69", "71", "73", "74", 
      "75", "77", "79", "81", "82", "83", "84", "85", "86", "87", "88", "89", "91", "92", "93", 
      "94", "95", "96", "97", "98", "99"
      ],
      salaryLiquid: 0,
      salaryLiquidToGetToSalaryTotal: 0,
      feedback: {},
      tabelaOutra: null,
      empresaTable: {},
      autonomoTable: {},
      cltTable: {},
      validacoes: {
        ...activeValidations,
        tipoContratacao: false,
        atividade: false,
        salario: false,
        tempoParaMudar: false,
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      },
      validators: {
        recebeMensalmente: new ValidatorSalary(),
      },
      contratacaoList: [
        { key: 'clt', value: 'CLT' },
        { key: 'empresa', value: 'PJ' },
        { key: 'autonomo', value: 'Autônomo' }
      ],
      tempoParaMudarList: [
        { key: 'menos1', value: 'Menos de 1 mês' },
        { key: 'de1a3', value: 'De 1 a 3 meses' },
        { key: 'mais3', value: 'Mais de 3 meses' }
      ],
      currentYear: new Date().getFullYear(),
    }
  },
  mounted() {
    this.VUE_APP_API_FORMS = `https://us-central1-oi-contabilizei${!this.isProd() ? '-test' : ''}.cloudfunctions.net/forms/hubspot/send`;

    this.VUE_APP_API_HUBSPOT = `https://us-central1-oi-contabilizei${!this.isProd() ? '-test' : ''}.cloudfunctions.net/leads/hubspot/`;

    const urlGetActivities = `https://api-gateway${!this.isProd() ? '-dev' : ''}.contabilizei.com/leads-${this.isProd() ? 'prod' : 'dev'}/public/atividades-empresa`;

    axios.get(urlGetActivities, { timeout: 1000 * 2 }).then(response => {
      this.atividades = response.data.map(atividade => {
        return {
          value: atividade.text,
          key: atividade.value
        }
      });
    }).catch(error => {
      console.log('Error fetching activities', error);
    });
  },
  computed:{
    customButtonStyle() {
      const { validacoes, tipoContratacao, salario, tempoParaMudar, atividade } = this;
      const customStyle = `
        background: #cdd4e2;
        borderColor: #cdd4e2;
        color: white;
        pointerEvents: none;
      `
      const valid = (validacoes.nome === undefined || (typeof validacoes.nome === 'boolean' && validacoes.nome)) &&
                    (validacoes.email === undefined || (typeof validacoes.email === 'boolean' && validacoes.email)) &&
                    (validacoes.celular === undefined || (typeof validacoes.celular === 'boolean' && validacoes.celular)) &&
                    tipoContratacao && salario && tempoParaMudar && atividade;
      return !valid ? customStyle : '';
    },
    customButtonStyleEspecialista() {
      const { validacoes } = this;
      const customStyle = `
        background: #cdd4e2;
        borderColor: #cdd4e2;
        color: white;
        pointerEvents: none;
      `
      const valid = (validacoes.nome === undefined || (typeof validacoes.nome === 'boolean' && validacoes.nome)) &&
                    (validacoes.email === undefined || (typeof validacoes.email === 'boolean' && validacoes.email)) &&
                    (validacoes.celular === undefined || (typeof validacoes.celular === 'boolean' && validacoes.celular)) &&
                    validacoes.atividade;
      return !valid ? customStyle : '';
    },
    filteredContratacaoList() {
      const withClt = this.contratacaoList.filter( i => i.key !== 'autonomo')
      const withAutonomo = this.contratacaoList.filter( i => i.key !== 'clt')
      const list = this.calculadoraTipo === 'id1' ? withClt : withAutonomo;

      return list;
    },
    tipoContratacaoFormatted() {
      return this.getTipoContratacaoFormatted(this.tipoContratacao)
    },
    tipoOpostoFormatted() {
      return this.getTipoContratacaoFormatted(this.tipoOposto)
    },
  },
  methods: {
    isProd() {
      return ['www.contabilizei.com.br', 'blog.contabilizei.com.br'].includes(window.location.hostname);
    },
    switchFunc(id) {
      this.calculadoraTipo = id;
      this.tipoContratacao = '';
      this.resetCalculo();
    },
    getDecimalNumber(text) {
      return text.replace(/[^\d\,]/g, '')
    },
    getFloatNumber(text) {
      const num1 = this.getDecimalNumber(text)
      const num2 = num1.replace(/\,/g, '.')
      return parseFloat(num2)
    },
    toFloatNumber(value) {
      if (!value) {
        return null;
      }

      return this.getFloatNumber(value);
    },
    getPayloadHubspot(validarFaturamento) {
      const validarColdCall = validarFaturamento && this.cidadeAtendida;
     
      return {
        tipo_de_contrato: this.tipoContratacao,
        eu_recebo_mensalmente: this.toFloatNumber(this.salario),
        segmento_profissao_site: this.atividade,
        beneficio_plano_de_saude: this.toFloatNumber(this.planoSaude),
        beneficio_vale_refeicao: this.toFloatNumber(this.valeRefeicao),
        beneficio_vale_transporte: this.toFloatNumber(this.valeTransporte),
        outros_beneficios: this.toFloatNumber(this.outrosBeneficios),
        opt_in: String(this.subscribe),
        origem: 'calculadora clt x pj',
        cidade_atendida: this.cidadeAtendida,
        city: this.locationValue,
        lifecyclestage:'lead',
        cidade_atendida_cold_call_materiais: validarColdCall ? 'Sim' : 'Não',
      };
    },
    async onClickContinue() {
        this.loading = true;
        const salario = this.toFloatNumber(this.salario);
        const validarFaturamento = salario >= 6000;
        let payloadHubspot = this.getPayloadHubspot(validarFaturamento);
        
        if(this.calculadoraTipo === 'id1') {
          const payload = await this.getResultsCalculation(payloadHubspot);
          payloadHubspot = this.addSalaryProperties(payload, payloadHubspot);
          this.$emit('onResults', payload);
        }
        const { tipoContratacao } = this;
        const {
          calculatorResultsEmpresa,
          calculatorResultsClt,
          calculatorResultsAutonomo
      } = calcularSalarios.calculate(tipoContratacao, salario, 'outros',  true);

      const results = {
        empresa: calculatorResultsEmpresa,
        clt: calculatorResultsClt,
        autonomo: calculatorResultsAutonomo
      }

      this.createTables(results)

        setTimeout(() => this.loading = false, 2000)
        this.isCalculoDone = true;

      this.enviarEventoHubspot(this.fields.email, 'calcular salario - calculadora clt x pj blog');
      this.triggerHubspot();
    },
    createTables(results) {
      const { tipoContratacao, calculadoraTipo } = this;
      let tipoOposto = '';

      tipoOposto = tipoContratacao === 'empresa' ? 'autonomo' : 'empresa';
      
      this.tabelaOutra = this.autonomoTable
     
      this.tipoOposto = tipoOposto
   
      if(this.calculadoraTipo === 'id2') {
        this.valueLeft = results[tipoContratacao].salaryLiquid
        this.valueRight = results[tipoOposto].salaryLiquidToGetToSalaryTotal
      }

      this.salaryLiquid = results[tipoContratacao].salaryLiquid;
      this.salaryLiquidToGetToSalaryTotal = results[tipoOposto].salaryLiquidToGetToSalaryTotal;
    },
    async getResultsCalculation(payloadHubspot) {
      const result = await this.calculate(payloadHubspot);

      const clt = result.calculatorResultsClt;
      const empresa = result.calculatorResultsEmpresa;
      const table = [
        {
          title: 'CLT',
          subtitle: 'Pessoa físicas',
          salaryValue: clt.salary,
          benefitsValue: clt.salaryLiquid,
        },
        {
          title: 'PJ',
          subtitle: 'Pessoa jurídica',
          salaryValue: empresa.salary,
          benefitsValue: empresa.salaryLiquid,
        },
      ];
   
      const salary = [];

      if (payloadHubspot.tipo_de_contrato === 'clt') {
        salary[0] = {
          text: 'Este é o seu salário líquido, considerando benefícios e descontos, como <strong>CLT</strong>:',
          value: clt.salaryLiquid,
        }
        salary[1] = {
          text: 'Para você ganhar o mesmo como <strong>PJ</strong> seu salário bruto mais benefícios deve ser:',
          value: empresa.salaryLiquidToGetToSalaryTotal,
        }
      } else {
        salary[0] = {
          text: 'Este é seu salário líquido trabalhando como <strong>PJ</strong>:',
          value: empresa.salaryLiquid,
        }
        salary[1] = {
          text: 'Para receber o mesmo como <strong>CLT</strong> seu salário bruto deve ser:',
          value: clt.salaryLiquidToGetToSalaryTotal,
        }
  
        table.reverse();
      }
      return {
        salary,
        table,
      };

    },
    addSalaryProperties(payload, payloadHubspot){
      const payloadCopy = { ...payloadHubspot };
      if (payloadCopy.tipo_de_contrato === 'clt') {
        this.valueLeft =  Number(payload.table[0].benefitsValue.toFixed(2));  
        this.valueRight = Number(payload.table[1].salaryValue.toFixed(2));
      } else {
        this.valueLeft =  Number(payload.table[0].benefitsValue.toFixed(2));
        this.valueRight = Number(payload.table[1].salaryValue.toFixed(2));
      }
      payloadCopy.salario_bruto_autonomo_calculadora_clt_pj = 0;
      payloadCopy.salario_liquido_autonomo_calculadora_clt_pj = 0;
      return payloadCopy;
    },
    calculate(data) {
      return new Promise(async (resolve) => {
        const {
          tipo_de_contrato,
          segmento_profissao_site,
          eu_recebo_mensalmente,
          beneficio_plano_de_saude,
          beneficio_vale_refeicao,
          beneficio_vale_transporte,
          outros_beneficios
        } = data;

        const listAnexos = this.getAnexoByActivity(segmento_profissao_site);

        const result = {
          type: tipo_de_contrato,
          salary: eu_recebo_mensalmente,
          healthPlan: beneficio_plano_de_saude,
          food: beneficio_vale_refeicao,
          transport: beneficio_vale_transporte,
          others: outros_beneficios,
          activity: segmento_profissao_site,
          anexos: listAnexos.anexos,
        };

        resolve(calculadoraCltPjV2.calculate(result));
      });
    },
    getAnexoByActivity(value) {
      return this.activityList.find(activity => activity.value === value);
    },
    selectTipoContratacao(key) {
      this.tipoContratacao = key
      if(key==='clt') {
        this.tipoOposto = 'empresa'
      }else {
        this.tipoOposto = 'clt'
      }
    },
    selectTempoParaMudar(key) {
      this.tempoParaMudar = key
    },
    selectAtividade(key) {
      this.atividade = key
      this.validacoes.atividade = key !== ''
    },
    getTipoContratacaoFormatted(tipo) {
      if (tipo === 'empresa') return 'PJ'
      else if (tipo === 'clt') return 'CLT'
      else return 'Autônomo'
    },
    falarEspecialista() {
      this.enviarEventoHubspot(this.fields.email, 'falar com especialista - calculadora clt x pj blog');
      this.feedbackContato = true
    },
    isSalariolValid() {
      this.validacoes.salario = this.salario >= 500
    },
    async triggerHubspot() {
      const tempoMudar = this.tempoParaMudarList.find( item => item.key === this.tempoParaMudar).value
      const cidadeAtendida = typeof croct !== 'undefined' ? await croct.evaluate('location\'s city') : ''
      const validarFaturamento = this.salario >= 6000
      const validarColdCall = validarFaturamento && 
                              (this.isCidadeAtendida(cidadeAtendida) ||  this.isEscritorioVirtual()) && 
                              this.subscribe

      let body = {
        ...(this.fields.nome && { nome: this.fields.nome }),
        ...(this.fields.email && { email: this.fields.email }),
        ...(this.fields.celular && { phone: this.fields.celular }),
        tipo_de_contrato: this.tipoContratacao,
        eu_recebo_mensalmente: this.toFloatNumber(this.salario),
        segmento_profissao_site: this.atividade,
        city: cidadeAtendida,
        clientid: window.Cookies.get('_gaclientid'),
        mudar_contratacao: tempoMudar,
        opt_in: String(this.subscribe),
        origem: 'calculadora clt x pj blog',
        lifecyclestage:'lead',
        cidade_atendida_cold_call_materiais: validarColdCall ? 'Sim' : 'Não',
      }

      this.criarContatoHubspot(body).then(res_contato => {
        if (res_contato.hash) {
          dataLayer.push({
            event: 'identificacao',
            email: this.fields.email,
            userID: res_contato.hash
          })
          dataLayer.push({
            event: 'hubspot-view',
            email: this.fields.email,
            userID: res_contato.hash
          })
          dataLayer.push({
            event: 'FormEventSubmission',
            eventCategory: 'Blog | Calculadora CLT x PJ',
            eventAction: 'Envio de formulários | Calculadora CLT x PJ',
            eventLabel: window.location.pathname
          })
        }
      })
    },
    isNomeValid() {
      /* eslint-disable-next-line */
      const re = /^(([a-z A-Z]{4,}))$/;

      this.validacoes.nome = re.test(this.fields.nome) && this.fields.nome
                      .trim()
                      .split(' ')
                      .length > 1;

      this.fields.nome = this.fields.nome.match(/[\p{Letter}\p{Mark}\s]+/gu).join('');
    },
    isEmailValid() {
      /* eslint-disable-next-line */
      const regexEmail = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
      regexEmail.test(this.fields.email) ? this.validacoes.email = true : this.validacoes.email = false

      if (regexEmail.test(this.fields.email)) {
        const getTld = this.fields.email.split('@')[1].split('.');
        const result = ListTlds.includes(getTld[1].toUpperCase());
        this.validacoes.email = result;
      }
    },
    isCelularValid() {
      let sameNumber = this.fields.celular
                      .slice(5)
                      .replace('-', '')
                      .split('')
                      .every(digit => digit === this.fields.celular[5]);

      this.validacoes.celular = this.fields.celular.length === 14 
                                && this.ddd.includes(this.fields.celular.substring(1, 3)) 
                                && this.fields.celular[4] === '9' 
                                && !sameNumber;
    },
    enviarEventoHubspot(email, evento) {
      return axios.post(`${this.VUE_APP_API_HUBSPOT}track-event`, {
        email,
        evento
      })
        .then(res => res.data)
    },
    criarContatoHubspot(contact) {
      if(!contact && !contact.email) {
        return
      };

      return this.sendByFormAPI(contact)
    },
    sendByFormAPI (param) {
      const payload = this.convertMotivoRecusa({ ...param });

      const context = {
        hutk: Cookies.get('hubspotutk'),
        pageUri: window.location.href,
        pageName: document.title
      }

      payload.context = context;

      return axios.post(`${this.VUE_APP_API_FORMS}`, payload)
        .then((result) => ({
          hash: result.data.hash
        }))
        .catch((error) => {
          Promise.reject('Error fetching api forms', error)
        });
    },
    resetCalculo() {
      if(!this.isCalculoDone) return
      this.cltTable = null
      this.autonomoTable = null
      this.empresaTable = null
      this.isCalculoDone = false
      this.salaryLiquid = 0
      this.salaryLiquidToGetToSalaryTotal = 0
      this.salario = ''
      this.tipoContratacao = ''
      this.tempoParaMudar = ''
      this.atividade = ''
    },
    scrollTo(idElement) {
      const element = document.getElementById(idElement)
      window.scroll({
        behavior: 'smooth',
        left: 0,
        top: element.offsetTop + 50
      })
    },
    convertMotivoRecusa(param) {
      if (param.motivos_recusa === ' ') {
        param.motivos_recusa = 'Nenhum'
      }
      return param
    },
    isCidadeAtendida(cidade) {
      return listaCidadesAtendidas.some((cidadeAtend) => {
        return this.formatCidade(cidadeAtend.cidade) === this.formatCidade(cidade)
      })
    },
    formatCidade(cidade) {
      return cidade.normalize('NFD').replace(/ /g, '').replace(/[\u0300-\u036f]/g, '').toLowerCase()
    },
    isEscritorioVirtual() {
     return this.atividade === 'servicos_de_ti' ? true : false;    
    }
  }
}
</script>

<style src="./style.css" lang="css" scoped></style>
